import { render, staticRenderFns } from "./AdminModuleSlides.vue?vue&type=template&id=5a74e391&scoped=true&"
import script from "./AdminModuleSlides.vue?vue&type=script&lang=js&"
export * from "./AdminModuleSlides.vue?vue&type=script&lang=js&"
import style0 from "./AdminModuleSlides.vue?vue&type=style&index=0&id=5a74e391&lang=less&scoped=true&"
import style1 from "./AdminModuleSlides.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a74e391",
  null
  
)

export default component.exports